import React from 'react';
import * as Sentry from '@sentry/react';

type SentryTestThrowBoundaryProps = {
  children: React.ReactNode;
  fallback: React.ReactNode;
};

type SentryTestThrowBoundaryState = {
  errorMessage?: string;
};

/**
 * Catches the test-page render throw and reports that Error to Sentry.
 * Does not console.error, so captureConsoleIntegration does not create a second issue.
 */
export class SentryTestThrowBoundary extends React.Component<
  SentryTestThrowBoundaryProps,
  SentryTestThrowBoundaryState
> {
  state: SentryTestThrowBoundaryState = {};

  /** Keep the thrown message so the fallback can confirm the client crash. */
  static getDerivedStateFromError(error: Error): SentryTestThrowBoundaryState {
    return { errorMessage: error.message };
  }

  /** Report the same Error instance the render path threw. */
  componentDidCatch(error: Error) {
    Sentry.captureException(error);
  }

  render(): React.ReactNode {
    if (this.state.errorMessage) return this.props.fallback;
    return this.props.children;
  }
}
